// extracted by mini-css-extract-plugin
export default {"label":"EditAuditorInfoTab_label__xB5-k"};